import { MethodType } from '../constants/MethodType'
const api = require('./api')

// ----- Dimension ----- //
export const fetchDimension = (params, id) => api.request(1, '/dimensions', MethodType.GET, params)

export const addDimension = params => api.request(1, '/dimensions', MethodType.POST, params)

export const modifyDimension = (id, params) => api.request(1, `/dimensions/${id}`, MethodType.PATCH, params)

export const deleteDimension = (id, params) => api.request(1, `/dimensions/${id}`, MethodType.DELETE, params, {}, false, {}, [403])

export const fetchDimensionDataSource = (brandId, params) => api.request(1, `/dataSourceTreeForDimension/${brandId}`, MethodType.GET, params)

export const fetchCrossDataSource = (brandId, params) => api.request(1, `/getCrossDataSourcesByBrand/${brandId}`, MethodType.GET, params)

export const fetchCrossDataSourceTree = (dataSourceId, params) => api.request(1, `/getDataSourceTreeByCrossDataSource/${dataSourceId}`, MethodType.GET, params)

// ----- Indicator ----- //
export const fetchIndicator = (params, id) => api.request(1, '/indicators', MethodType.GET, params)

export const addIndicator = params => api.request(1, '/indicators', MethodType.POST, params)

export const modifyIndicator = (id, params) => api.request(1, `/indicators/${id}`, MethodType.PATCH, params)

export const deleteIndicator = (id, params) => api.request(1, `/indicators/${id}`, MethodType.DELETE, params)

export const fetchDimensionBySource = (dataSrcId, tableName, params) => api.request(1, `/getDimensionByDataSource/${dataSrcId}/${tableName}`, MethodType.GET, params)

export const fetchDimensionByIndicator = (indicator1, indicator2, params) => api.request(1, `/getDimensionByIndicator/${indicator1}/${indicator2}`, MethodType.GET, params)

export const fetchDimensionByCrossData = (crossDataSourceId, params) => api.request(1, `/getDimensionByCrossDataSource/${crossDataSourceId}`, MethodType.GET, params)

export const fetchIndicatorByDimension = (brandId, params) => api.request(1, `/getIndicatorByDimension/${brandId}`, MethodType.GET, params)

// ----- Indicator Preview and Download ----- //
export const fetchIndicatorPreview = (id, params) => api.request(1, `/indicatorResultPreview/${id}`, MethodType.GET, params)

export const donwloadIndicator = params => api.request(1, '/indicatorResultDownload', MethodType.POST, params, {}, false, { responseType: 'blob' })
